import { useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import "./header.css";

const Header = ({ cmsLabels }) => {
  const { isCheckedEmail, isInValidEmail } = useSelector(
    (state) => state.email
  );
  const {
    isPostChecked,
    isStreetInValid,
    isCityInValid,
    isSelectedStateInValid,
    isZipCodeInValid,
  } = useSelector((state) => state.postMail);
  const { isInValidFirstName, isInValidLastName } = useSelector(
    (state) => state.names
  );
  const {
    isHomePhoneInValid,
    isWorkPhoneInValid,
    isExtensionInValid,
    isPhoneChecked,
    isCheckedExtension,
  } = useSelector((state) => state.phone);

  const { isMobileInValid, isCheckedMobile } = useSelector(
    (state) => state.mobile
  );
  const { isSMSInValid, isCheckedSMS } = useSelector((state) => state.sms);
  const { isCheckedFax, isFaxInvalid } = useSelector((state) => state.fax);
  const { isCheckedWhatsApp, isWhatsAppInValid } = useSelector(
    (state) => state.whatsapp
  );

  return (
    <div>
      <h1 className="dds__sr-only">Unsubscribe from Dell Marketing Emails</h1>
      <h5
        className="dds__font-weight-bold"
        dangerouslySetInnerHTML={{
          __html: cmsParser(cms.Please_Unsubscribe, cmsLabels),
        }}
      ></h5>
      <p>{cmsParser(cms.Required_Fields, cmsLabels)}</p>

      {(isCheckedEmail && isInValidEmail) ||
      (isCheckedWhatsApp && isWhatsAppInValid) ||
      (isPostChecked &&
        (isStreetInValid ||
          isCityInValid ||
          isSelectedStateInValid ||
          isZipCodeInValid)) ||
      (isPhoneChecked && (isWorkPhoneInValid || isHomePhoneInValid)) ||
      (isCheckedMobile && isMobileInValid) ||
      (isCheckedSMS && isSMSInValid) ||
      (isCheckedFax && isFaxInvalid) ||
      ((isPostChecked ||
        isPhoneChecked ||
        isCheckedMobile ||
        isCheckedFax ||
        isCheckedSMS) &&
        isInValidFirstName) ||
      ((isPostChecked ||
        isPhoneChecked ||
        isCheckedMobile ||
        isCheckedFax ||
        isCheckedSMS) &&
        isInValidLastName) ? (
        <div
          id="validationErrors"
          className="dds__message-bar dds__message-bar--warning"
        >
          <i
            className="dds__icon dds__message-bar__icon dds__icon--alert-notice"
            aria-hidden="true"
          ></i>
          <div>
            {isCheckedEmail && isInValidEmail ? (
              <p className="fieldError">
                {cmsParser(cms.validation_email, cmsLabels)}
              </p>
            ) : null}

            {isPostChecked && isStreetInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_street_address, cmsLabels)}
              </p>
            ) : null}

            {isPostChecked && isCityInValid ? (
              <p className="fieldError">
                {cmsParser(cms.valIdation_city, cmsLabels)}
              </p>
            ) : null}

            {isPostChecked && isSelectedStateInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_select_state, cmsLabels)}
              </p>
            ) : null}

            {isPostChecked && isZipCodeInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_zip_code, cmsLabels)}
              </p>
            ) : null}

            {isPhoneChecked && isHomePhoneInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_home_phone, cmsLabels)}
              </p>
            ) : null}

            {isPhoneChecked && isWorkPhoneInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_phone, cmsLabels)}
              </p>
            ) : null}

            {isPhoneChecked && isCheckedExtension && isExtensionInValid ? (
              <p className="fieldError">
                {/* {cmsParser(cms.validation_home_phone, cmsLabels)} */}
                Please Add a valid Extension
              </p>
            ) : null}

            {isCheckedMobile && isMobileInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_mobile, cmsLabels)}
              </p>
            ) : null}

            {isCheckedFax && isFaxInvalid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_fax, cmsLabels)}
              </p>
            ) : null}

            {isCheckedSMS && isSMSInValid ? (
              <p className="fieldError">
                {cmsParser(cms.validation_SMS, cmsLabels)}
              </p>
            ) : null}

            {isCheckedWhatsApp && isWhatsAppInValid && (
              <p className="fieldError">
                {/* {cmsParser(cms.validation_SMS, cmsLabels)}
                 */}
                {cmsParser(cms.validation_phone, cmsLabels)}
              </p>
            )}

            {(isPostChecked ||
              isPhoneChecked ||
              isCheckedMobile ||
              isCheckedFax ||
              isCheckedSMS) &&
            isInValidFirstName ? (
              <p className="fieldError">
                {cmsParser(cms.validation_first_name, cmsLabels)}
              </p>
            ) : null}

            {(isPostChecked ||
              isPhoneChecked ||
              isCheckedMobile ||
              isCheckedFax ||
              isCheckedSMS) &&
            isInValidLastName ? (
              <p className="fieldError">
                {cmsParser(cms.validation_last_name, cmsLabels)}
              </p>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Header;
